import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, useTheme } from '@mui/material';

import CommonTop from '@/component/pools/CommonTop';
import PoolsDetailTable from '@/component/pools/table/PoolsDetailTable';
import PoolExplain from '@/component/pools/PoolExpplain/PoolExplain';
import { EvmTxHistory, PoolListType } from '@/types';
import { evmTxHistoryList } from '@/api/evmScan/txList';
import Overview from '@/component/pools/OverView';
import WarningSvg from '@/assets/assetfi/Warning';
import ChevronLeftSvg from '@/assets/assetfi/ChevronLeft';
import { poolDetail } from '@/api/staking/read';

const PoolDetail = () => {
  const {
    state: { contractAddr, poolId },
  } = useLocation();
  const theme = useTheme();

  // router
  const navigate = useNavigate();

  const [detail, setDetail] = useState<PoolListType | null>(null);

  const txList = useRef<EvmTxHistory[] | null>(null);

  useEffect(() => {
    (async () => {
      console.log('contractAddr', contractAddr);
      console.log('poolId', poolId);
      if (!contractAddr || !poolId) {
        navigate('/');
        return;
      }
      if (process.env.NODE_ENV === 'production') {
        const re = await evmTxHistoryList(contractAddr);
        if (!re?.length) {
          return;
        }
        const result: EvmTxHistory[] = re.filter((item: EvmTxHistory, index: number) => {
          return (
            item.isError === '0' &&
            (item.functionName.startsWith('stakeToken') ||
              item.functionName.startsWith('unStakeToken') ||
              item.functionName.startsWith('ClaimReward'))
          );
        });
        txList.current = result;
      }

      try {
        const re = await poolDetail(poolId);
        setDetail(re.data);

        // const re = await promiseAllSettled(arrPromise);
        // setDetail(re[0]);
      } catch (e) {
        console.error(e);
      }
    })();
    return () => {};
  }, [contractAddr, poolId]);

  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', md: '0px' },
      }}
    >
      {/* Pool Title Section */}
      <CommonTop
        sx={{
          display: {
            xs: 'none',
            md: 'block',
          },
        }}
        avatar
        title={detail ? detail.title : ''}
        subtitle="Pools Of Real-World Assets"
      />

      {/* Pool Content Section */}
      <Box
        sx={{
          padding: '24px',
          maxWidth: '1680px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <WarningSvg width={20} height={20} />
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '12px',
              letterSpacing: '-0.02em',
              lineHeight: '14.52px',
            }}
          >
            Make investment decisions carefully after thorough consideration.
          </Typography>
        </Box>

        <Box
          sx={{
            background: '#357AFF1A',
            borderRadius: '15px',
            padding: '4px 16px',
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            cursor: 'pointer',
            marginTop: '24px',
            width: '160px',
          }}
          onClick={() => navigate('/pools')}
        >
          <ChevronLeftSvg width={5} height={10} />
          <Typography variant="body4" color={theme.greyscale.darkgrey2}>
            Back To Open Pools
          </Typography>
        </Box>
        {detail && <PoolExplain contractAddr={contractAddr} detail={detail} />}
      </Box>

      {/* Overview Section */}
      <Overview contractAddr={contractAddr} txList={txList.current} detail={detail} />

      {/* Recent Activity Section */}
      <PoolsDetailTable list={txList?.current} />
    </Box>
  );
};

export default PoolDetail;
